// extracted by mini-css-extract-plugin
export default {"active-icon":"LeftPanel_active-icon__Ff9E4","spinning-ai":"LeftPanel_spinning-ai__Jg9ZF","spin":"LeftPanel_spin__uF12-"};